var storeLocal = {};
if (window.store && store.local) storeLocal = store.local;
var storeAdmin = {};
if (window.store && store.admin) storeAdmin = store.admin;
store = {};
store.local = storeLocal;
store.admin = storeAdmin;
store.action = {};
store.action.cartAdd = 'cart/add';
store.action.cartDelete = 'cart/delete';
store.action.cartAdjust = 'cart/adjust';
store.action.cartClear = 'cart/clear';
store.action.cartBox = 'cart/box';
store.action.cartView = 'cart/view';
store.action.cartMedium = 'cart/medium';
store.action.terms = 'index/terms';
store.action.countrySelection = 'index/countryselection';
store.url = function (action, extra) {
	var extraParam = (extra) ? '/' + extra : '';
	return '/_/' + moya.division + '/store/' + action + extraParam;
};
store.$store = null;
store.$ = function() {
	if (null === store.$store) {
		var r = $('#store');
		if (r.length > 0) {
			store.$store = r;
		}
	}
	return store.$store;
};

store.initProduct = function() {
	store.updateBuyButton();
	store.customize.onInitProduct();
	store.local.onInitProduct();
};
// Called by $(document).ready
store.init = function () {
	//noinspection JSUnusedLocalSymbols
	$('.cartAdd').submit(function (data) {
		var f = $(this);
		var params;
		if (window.FormData) {
			params = new FormData(f.get(0));
		}
		else {
			params = {
				variant :f.find('#variant').val(),
				qty :f.find('#qty').val(),
				price :f.find('#price').val(),
				category :f.find('#category').val()
			};
		}
		store.cart.add(params);
		return false;
	});

	//noinspection JSUnusedLocalSymbols
	$('#storeCartBox').delegate('.cartClear', 'click', function (data) {
		store.cart.clear();
		return false;
	});

	$('body').delegate('.cartView .delete', 'click', function(e){
		e.preventDefault();
		store.cart.remove($(this).attr('id').substr(7));
	}).delegate('.cartView .increase', 'click', function(e){
		e.preventDefault();
		store.cart.increase($(this).attr('id').substr(9));
	}).delegate('.cartView .decrease', 'click', function(e){
		e.preventDefault();
		store.cart.decrease($(this).attr('id').substr(9));
	}).delegate('.cartView .cartClear', 'click', function(e){
		e.preventDefault();
		store.cart.clear();
	});

	$('div.elm_Terms label em').click(store.launchTerms).css('cursor', 'pointer');
	$('a.changeCountry').click(store.changeCountryClick);
	store.local.onInit();
};

store.attributeSort = [];
store.attributes = {};
store.variants = {};
store.initialProductClasses = [];

store.initAttributes = function(data, currentVariantKey) {
	var $store = store.$();
	var wrap = $store.find('.variantSelection');
	var html = '';
	store.attributeSort = data.attributeSort;
	store.attributes = data.attributes;
	store.variants = data.variants;
	store.initialProductClasses = $store.find('.product').attr('class').split(' ');

	for (var i= 0,c=data.attributeSort.length; i<c; i++) {
		var aId = data.attributeSort[i];
		//noinspection JSUnfilteredForInLoop
		var a = data.attributes[aId];
		var aData = a.data;
		if (aData.isOption) {
			var selectId = 'attribute_' + aData.codename;
			a.selectId = selectId;
			var label = '<label for="' + selectId + '">' + aData.name + ':</label>';
			var aType = aData.type;
			var select = '';
			if (aType == 'color') {
				select = store.attributeColorSelect(selectId, a.values);
			}
			else {
				select = store.attributeNormalSelect(selectId, a.values);
			}

			html += '<div class="attribute">' + label + select + '</div>';
		}
	}
	wrap.html(html);
	$store.find('.attribute select').change(function(){
		store.updateVariantData();
	});
	$store.find('.attribute span.color').click(store.updateVariantColor);
	store.selectVariant(currentVariantKey);
};

store.attributeNormalSelect = function(selectId, values) {
	var options = '';
	for (var vId in values) {
		//noinspection JSUnfilteredForInLoop
		var v = values[vId];
		options += '<option value="' + vId.replace('v', '') + '">' + v.value + '</option>';
	}
	return '<select id="' + selectId + '">' + options + '</select>';
};
store.AttributeValue = {
	extraValue: null
};
store.attributeColorSelect = function(selectId, values) {
	var options = '';
	for (var vId in values) {
		//noinspection JSUnfilteredForInLoop
		var v = values[vId];
		var vvId = vId.replace('v', '');
		if (v.extraValue.indexOf('#') !== 0) {
			v.extraValue = '#' + v.extraValue;
		}
		options += '<span class="color c_' + vvId +
			'" style="background: ' + v.extraValue + '" rel="' + vvId +
			'" title="' + v.value + '">&nbsp;</span>';
	}
	var hidden = '<input type="hidden" name="' + selectId + '" id="' + selectId + '" />';
	return '<span class="colorWrap" id="' + selectId + '_wrap">' + hidden + options + '</span>';
};

store.updateVariantColor = function() {
	var t = $(this);
	var rel = t.attr('rel');
	var p = t.parent();
	$('input', p).val(rel);
	store.updateVariantData();
};
store.Variant = {
	price: null,
	stock: null,
	qty: null,
	reference: null,
	compareLink: null,
	attributes: null,
	img: null,
	priceId: null
};
store.Attribute = {
	name: null, codename: null, type: null, isOption: null
};
store.getVariantAttributeData = function(variant) {
	var ret = {};
	if (variant && variant.attributes) {
		for (var k in variant.attributes) {
			if (variant.attributes.hasOwnProperty(k)) {
				var kk = 'a'+k;
				if (store.attributes[kk] && store.attributes[kk].data.codename) {
					ret[store.attributes[kk].data.codename] = variant.attributes[k];
				}
			}
		}
	}
	return ret;
};
store.updateVariantClasses = function(variant) {
	var $product = store.$().find('.product');
	var classes = store.initialProductClasses;
	var variantClasses = variant.classes;
	if (variantClasses) {
		classes = classes.concat(variantClasses);
	}
	$product.attr('class', classes.join(' '));
};
store.updateVariantData = function() {
	var values = [];
	var aId, a, sel, i, c;
	for (i = 0,c = store.attributeSort.length; i < c; i++) {
		aId = store.attributeSort[i];
		//noinspection JSUnfilteredForInLoop
		a = store.attributes[aId];
		if (a.selectId) {
			//noinspection JSJQueryEfficiency
			sel = $('#' + a.selectId);
			var v1 = sel.val();
			if (v1) {
				v1 = parseInt(v1);
				values.push(v1);
			}
		}
	}

	var key = values.join('_');
	if (store.variants[key]) {
		var variant = store.variants[key];
		var $store = store.$();
		$store.find('.buyBox .priceDetail .priceValue').html(variant.price);
		$store.find('.availability').replaceWith(variant.stock);
		$store.find('div.qtyWrap').replaceWith(variant.qty);
		$store.find('div.reference').replaceWith(variant.reference);
		if (variant.compareLink) {
			$store.find('div.compareLink').replaceWith(variant.compareLink);
		}

		$store.find('.product .side .image').replaceWith(variant.img);
		$store.find('.product .side .image a.fancybox').fancybox();
		store.responsiveImg($store.find('.product .side .image'));
		$store.find('#variant').val(variant.id).trigger('change');
		$store.find('#price').val(variant.priceId).trigger('change');
		store.updateAttributes(variant);
		store.updateBuyButton();
		store.updateVariantClasses(variant);

		for (i= 0,c=store.attributeSort.length; i<c; i++) {
			aId = store.attributeSort[i];
			//noinspection JSUnfilteredForInLoop
			a = store.attributes[aId];
			if (a.data.type == 'color') {
				//noinspection JSJQueryEfficiency
				sel = $('#' + a.selectId);
				var v2 = sel.val();
				var wrap = $('#' + a.selectId + '_wrap');
				wrap.find('.color').removeClass('selected');
				wrap.find('.c_' + v2).addClass('selected');
			}
		}
		store.local.onUpdateVariantData(variant);
	}
	else {
		store.message.error(store.t.__('variantNotAvailable'), 'Error', null, 'updateVariantData');
	}
};

store.updateAttributes = function(variant) {
	var $table = store.$().find('.attributesValues table');
	if ($table.length > 0) {
		$table.find('tr').each(function() {
			var $t = $(this);
			var r = parseInt($t.attr('rel'));
			if (r > 0 && variant.attributes) {
				var t = (variant.attributes[r]) ? variant.attributes[r] : '';
				$t.find('td').text(t);
			}
		});
	}
	store.local.onUpdateAttribute(variant);
};
store.updateBuyButton = function() {
	var allowedToAdd = (store.$().find('div.qtyWrap #qty').length > 0);
	store.$().find('#submitCart').attr('disabled', !allowedToAdd);
};

store.selectVariant = function (currentVariantKey)
{
	var values = currentVariantKey.split('_');
	for (var i= 0,cas=store.attributeSort.length; i<cas; i++) {
		var aId = store.attributeSort[i];
		for (var v= 0, c=values.length; v < c; v++) {
			var vId = values[v];
			var vvId = 'v'+vId;
			//noinspection JSUnfilteredForInLoop
			if (store.attributes[aId].values[vvId]) {
				//noinspection JSUnfilteredForInLoop
				var e = $('#' + store.attributes[aId].selectId);
				e.val(vId);
			}
		}
	}
	store.updateVariantData();
	store.local.onSelectVariant(currentVariantKey);
};

store.termsDialogParams = {
	modal: true,
	height: 300,
	width: 500
};
store.launchTerms = function() {
	var $link = $(this);
	var $dialog = $('#storeDialog');
	if ($dialog.length === 0) {
		$dialog = $('<div id="storeDialog" style="display:none"></div>').appendTo('body');
	}
	store.local.prepareTermsDialogParams($dialog, $link);
	$dialog.load(
		store.url(store.action.terms, ''),
		{},
		function () {
			$dialog.dialog(store.termsDialogParams);
		}
	);
	return false;
};

store.initPaymentSelection = function() {
	$('ul.paymentTypeSelection li').click(function(){
		$('input', this).attr('checked','checked');
	});
};

store.changeCountryClick = function(e) {
	var dialog = $('#storeDialog');
	if (dialog.length === 0) {
		dialog = $('<div id="storeDialog" style="display:none"></div>').appendTo('body');
	}
	var title = (this.title) ? this.title : '';
	dialog.load(
		store.url(store.action.countrySelection, ''),
		{},
		function () {
			dialog.dialog({
				modal: true,
				height: 200,
				width: 400,
				title: title
			});
		}
	);
	e.preventDefault();
	return false;
};

store.sorter = {};
store.sorter.init = function() {
	var $f = $('#storeSorter').find('form');
	store.form.autoChange($f, 'storeSelector');
	store.form.ajax($f, {
		'.categoryProducts': '#store .category .categoryProducts'
	}, function() {
		store.local.onCategoryProductsUpdate();
	});
};
store.t = {};
store.t.translations = {};
store.t.addTranslations = function(a) {
	jQuery.extend(store.t.translations, a);
};
store.t.__ = function(k) {
	var r = k;
	if (store.t.translations[k]) {
		r = store.t.translations[k];
	}
	return r;
};
// http://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-money-in-javascript/149099#149099
store.numberFormat = function(n, decPlaces, thouSeparator, decSeparator) {
	decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces;
	decSeparator = (typeof decSeparator == 'undefined') ? "." : decSeparator;
	thouSeparator = (typeof thouSeparator == 'undefined') ? "," : thouSeparator;
	var sign = n < 0 ? "-" : "";
	var i = parseInt(n = Math.abs(+n || 0).toFixed(decPlaces)) + "";
	var j;
	j = (j = i.length) > 3 ? j % 3 : 0;
	return sign +
		(j ? i.substr(0, j) + thouSeparator : "") +
		i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thouSeparator) +
		(decPlaces ? decSeparator + Math.abs(n - i).toFixed(decPlaces).slice(2) : "");
};

store.responsiveImg = function($parent, selector) {
	if ($.isFunction($.fn.responsiveImg)) {
		if (!selector) selector = 'img.responsive';
		if (!$parent) $parent = $('#store');
		if ($parent instanceof jQuery) {
			$parent.find(selector).responsiveImg();
		}
	}
};
store.isFormRequirementsValid = function($form) {
	var $requiredElements = $form.find(':input[aria-required=true]').filter(':visible');
	var ret = true;
	$requiredElements.each(function(){
		var val = $(this).val();
		if (!val || val.length < 0) {
			ret = false;
			return false; // break
		}
	});
	return ret;
};
store.makeRadioGroupDeselectable = function (parentElement) {
	if (!NodeList.prototype.forEach) {
		return;
	}

	var current;
	parentElement.querySelectorAll('input[type=radio]').forEach(function (elm) {
		elm.addEventListener('click', function (e) {
			if (this.id === current) {
				this.checked = false;
				current = null;
				// only time the click is not triggered in jQuery
				$(this).trigger('change');
			}
			else {
				current = this.id;
			}
		});
		if (elm.checked) {
			current = elm.id;
		}
	});
};

store.message = {};
store.message.add = function (msg, title, img, cssClass, action) {
	// @todo make pretty
	if (title === undefined || title === null) {
		title = 'Store';
	}
	if (msg === undefined || msg === null) {
		msg = '&nbsp';
	}
	if (cssClass === undefined || cssClass === null) {
		cssClass = 'normal';
	}
	if (action === undefined || action === null) {
		action = 'undefined';
	}
	var options = {
		title: title,
		text: msg,
		sticky: false,
		class_name: cssClass,
		action: action
	};
	if (undefined !== img) {
		options.image = img;
	}
	store.message.showMessage(options);
};

store.message.showMessage = function (options) {
	if (store.local.showMessage) {
		store.local.showMessage(options)
	}
	else {
		store.message.showGritter(options);
	}
};

store.message.showGritter = function (options) {
	if ($.gritter) {
		$.gritter.add(options);
	}
};

store.message.error = function (msg, title, img, action) {
	store.message.add(msg, title, img, 'error', action);
};

// Cart related
store.cart = {};

/**
 * @todo What should be done with the message !
 * @param params
 */
store.cart.add = function (params) {
	var isFormData = params instanceof FormData;
	var $form;
	var $body = $('body');
	if (this && this.tagName === 'FORM') {
		$form = $(this);
	}
	else {
		$form = $('#store').find('form.cartAdd');
	}
	$body.addClass('cart-adding');
	document.body.style.cursor = 'wait';
	$.ajax({
		type: 'POST',
		url: store.url(store.action.cartAdd),
		data: params,
		cache: false,
        contentType: isFormData ? false : false,
        processData: isFormData ? false : false,
		dataType: 'json',
		success: function (data) {
			$body.removeClass('cart-adding');
			document.body.style.cursor = 'default';

			if (!data) {
				return;
			}
			// var className = (data.success) ? 'success' : 'error';
			// example: moya.message.add(data.message, className);
			if (data.success === true) {
				store.cart.box();
				store.message.add(data.message, data.title, data.image, null, 'cartAdd');
				store.customize.onAddToCart(data);
				store.local.onAddToCart(data);
			}
			else {
				store.message.error(data.message, data.title, null, 'cartAdd');
				if (data.fields && data.fields.length && $form && $form.length > 0) {
					for (var i = 0; i < data.fields.length; i++) {
						var field = data.fields[i];
						var $elm = $form.find('#elm_' + field);
						$elm.addClass('hasError');
						if (i === 0) {
							$elm.find(':input').first().focus();
						}
					}
				}
			}
		}
	});
};

store.cart.remove = function (params) {
	$.get(store.url(store.action.cartDelete, params), function (data) {
		if (data.success === true) {
			store.cart.box();
			store.cart.view();
			store.message.add(data.message, data.title, data.image, null, 'cartRemove');
		}
		else {
			store.message.error(data.message, data.title, null, 'cartRemove');
		}
	}, 'json');
};
store.cart.increase = function (params) {
	$.get(store.url(store.action.cartAdjust, params + '/1'), function (data) {
		if (data.success === true) {
			store.cart.box();
			store.cart.view();
			store.message.add(data.message, data.title, data.image, null, 'cartIncrease');
			store.local.onCartIncrease();
		}
		else {
			store.message.error(data.message, data.title, null, 'cartIncrease');
		}
	}, 'json');
};

store.cart.decrease = function (params) {
	$.get(store.url(store.action.cartAdjust, params + '/-1'), function (data) {
		if (data.success === true) {
			store.cart.box();
			store.cart.view();
			store.message.add(data.message, data.title, data.image, null, 'cartDecrease');
			store.local.onCartDecrease();
		}
		else {
			store.message.error(data.message, data.title, null, 'cartDecrease');
		}
	}, 'json');
};

store.cart.clear = function () {
	$.get(store.url(store.action.cartClear, ''), function (data) {
		if (data.success === true) {
			store.cart.box();
			store.cart.view();
			store.message.add(data.message, data.title, data.image, null, 'cartClear');
		}
		else {
			store.message.add(data.message, null, null, null, 'cartClear');
		}
	}, 'json');
};

store.cart.box = function () {
	$.get(store.url(store.action.cartBox, ''), function (data) {
		var $box = $('#storeCartBox');
		$box.find('.boxText').html(data.html);
		$box.effect("highlight", {color:"#ccc"}, 1000);
		store.local.onCartBox($box, data);
	}, 'json');
};

store.cart.view = function () {
	$.get(store.url(store.action.cartView, ''), function (data) {
		store.$().find('.cartView').replaceWith(data.html);
		store.responsiveImg(store.$().find('.cartView'));
	}, 'json');
};

store.cart.medium = function () {
	$.get(store.url(store.action.cartMedium, ''), function (data) {
		$.fancybox({
			content: data.html
		});
	}, 'json');
};
store.cart.saved = {};
store.cart.saved.init = function() {
	var $form = $('#storeCartSave');
	if ($form.length < 1) {
		var $msg = $('#storeSavedCartSaved');
		if ($msg.length > 0) {
			tb_remove();
			store.message.add($msg.text(), $msg.text(), '', null, 'cartSaved');
		}
		return;
	}
	var $name = $form.find('#name');
	if ($name.length < 1) return;
	var $overwrite = $form.find('#elm_overwrite');
	var orig = $name.data('orig');
	var sources = [];
	if ($name.prop('tagName') === 'SELECT') {
		sources = $name.find('option').map(function(){
			return this.value;
		});
	}
	else {
		var tmp = $name.data('source');
		if (tmp) {
			sources = tmp.split(', ');
		}
		$overwrite.hide();
		var checkOverwrite = function(forcedValue) {
			var cName = (forcedValue) ? forcedValue : $name.val();
			$overwrite.find('#overwrite').prop('checked', false);
			if (cName === orig) {
				$overwrite.hide();
				$overwrite.find('#overwrite').prop('checked', true);
			}
			else if (sources.indexOf(cName) > -1) {
				$overwrite.show();
			}
			else {
				$overwrite.hide();
			}
		};
		$name.autocomplete({
			source: sources,
			select: function(event, ui) {
				checkOverwrite(ui.item.value);
			}
		});
		var delay = (function () {
			var timer = 0;
			return function (callback, ms) {
				clearTimeout(timer);
				timer = setTimeout(callback, ms);
			};
		})();
		$name.keyup(function() {
			delay(function(){
				checkOverwrite();
			}, 400);
		});

		var def = $name.data('default');
		if (def) {
			$name.val(def);
		}
		if ($name.val().length > 0) {
			checkOverwrite();
		}
	}
};


store.form = {};
store.form.autoChangeTimeout = null;
store.form.ajaxLastRequest = null;
store.form.autoChange = function($form, formClass) {
	$form.find('input[type=submit]').hide();
	$form.find(':input').change(function(){
		var changedName = this.name;
		var changedTo = $(this).val();
		var checked = (this.type === 'checkbox' || this.type === 'radio') ? this.checked : true;
		var isMultiple = ($form.find('[name='+changedName+']').length > 1);
		var formName = $form.parent().attr('id');
		$('form.'+formClass).each(function(){
			var $t = $(this);
			var n = $t.parent().attr('id');
			if (n != formName) {
				var $es = $t.find('[name='+changedName+']');
				if (isMultiple) {
					$es = $es.filter('[value='+changedTo+']');
				}
				if (checked && $es.length < 1) {
					var $h = $('<input type="hidden" name="'+changedName+'" />');
					$h.appendTo($t);
					$es = $h;
				}
				if (checked) {
					$es.val(changedTo);
				}
				else {
					$es.remove();
				}
			}
		});

		clearTimeout(store.form.autoChangeTimeout);
		if (store.form.ajaxLastRequest) {
			store.form.ajaxLastRequest.abort();
		}
		store.form.autoChangeTimeout = setTimeout(function(){
			$(document.body).addClass('waiting');
			$form.trigger('submit');
		}, 300);
	});
};
store.form.ajax = function($form, dests, callback) {
	$form.submit(function(){
		var opts = store.form.getOpts($form);
		jQuery.extend(opts, {
			success: function(content) {
				store.form.ajaxLastRequest = null;
				var isSuccess = false;
				if (content.length > 0) {
					isSuccess = true;
					var toUrl = this.url;
					if (toUrl.indexOf('?') === -1) {
						toUrl += '?';
					}
					history.replaceState({}, null, toUrl);
					store.$().find('.paginationControl a').each(function(){
						var newUrl = toUrl.replace(/&?page=[0-9]+&?/, '') + '&page=$1';
						//noinspection JSPotentiallyInvalidUsageOfThis
						this.href = this.href.replace(/.*page=([0-9]+).*/, newUrl);
					});
					if (typeof dests === 'string') {
						dests = {'': dests};
					}
					var $tmp = $('<div/>').html(content);
					for (var key in dests) {
						if (!dests.hasOwnProperty(key)) {
							continue;
						}
						var dest = dests[key];
						var $d = $(dest);
						var $content;
						if (key === '') {
							$content = $(content);
						}
						else {
							$content = $tmp.find(key);
						}
						if ($content.length > 0) {
							$d.replaceWith($content);
							store.responsiveImg($content);
						}
						else {
							isSuccess = false;
						}
					}
				}
				$(document.body).removeClass('waiting');
				if (isSuccess && typeof callback === 'function') {
					callback();
				}
			}
		});
		store.form.ajaxLastRequest = $.ajax(opts);
		return false;
	});
};
store.form.getOpts = function($form) {
	return {
		url: $form.get(0).action.replace(/\?.*/, ''),
		data: $form.formSerialize().replace(/[a-z0-9-]+=(&|$)/g,'').replace(/&$/, ''),
		type: "GET",
		dataType: "html"
	};
};



store.filters = {};
store.filters.init = function() {
	var $f = $('#storeFilters').find('form');
	if ($f.hasClass('inited')) {
		return;
	}
	$f.find('.storeSlider').each(store.filters.slider);
	$f.find('.filter.Radio').each(store.filters.radio);
	store.form.autoChange($f, 'storeSelector');
	store.form.ajax($f, {
		'.categoryProducts': '#store .category .categoryProducts',
		'#storeFilters': '#storeFilters'
	}, function() {
		store.filters.init();
		store.local.onCategoryProductsUpdate();
		store.local.onFilterUpdate();
	});
	$f.addClass('inited');
};
store.filters.radio = function () {
	store.makeRadioGroupDeselectable(this);
};
store.filters.slider = function() {
	var $t = $(this);
	var rel = $t.attr('rel');
	var t = rel.split('-');
	if (t.length === 2) {
		var min = parseInt(t[0]);
		var max = parseInt(t[1]);
		var $input = $t.parent().find('input.hidden');
		// Hide the nonJS options
		$t.parent().find('.options').hide();
		var current = $input.val();
		var values = (current.match(/-/)) ? current.split('-') : [min, max];
		var step = Math.ceil(max*0.05);

		$t.slider({
			range: true,
			min: min,
			max: max,
			values: values,
			step: step,
			slide: function(event, ui) {
				store.filters.sliderChange($t, ui.values);
			},
			change: function() {
				$input.trigger('change');
			}
		});
		store.filters.sliderChange($t, values);
	}
};
store.filters.sliderChange = function($slider, values) {
	var min = parseInt(values[0]);
	var max = parseInt(values[1]);
	var $input = $slider.parent().find('.hidden');
	var sliderMin = $slider.slider('option', 'min');
	var sliderMax = $slider.slider('option', 'max');
	if (sliderMin === min && sliderMax === max) {
		$input.val('');
	}
	else {
		$input.val(min + "-" + max);
	}
	var $label = $slider.parent().find('.label');
	if ($input.hasClass('price')) {
		$label.html(store.price.format(min) + " - " + store.price.format(max));
	}
	else {
		var format = $input.attr('rel') || '%value%';
		$label.html(store.filters.format(min, format) + " - " + store.filters.format(max, format));
	}
};
store.filters.format = function(value, format) {
	return format.replace('%value%', value);
};

store.price = {};
store.price._format = {
	sign: "kr.",
	numDecs: 0,
	sepDec: '.',
	sepThou: ',',
	signLeft: false,
	space: true
};
store.price.setFormat = function(format) {
	store.price._format = format;
};
store.price.format = function(value) {
	var ret;
	var f = store.price._format;
	ret = store.numberFormat(value, f.numDecs, f.sepThou, f.sepDec);
	var symbol = f.sign;
	var sp = (f.space > 0) ? ' ': '';
	if (f.signLeft > 0) {
		ret = symbol + sp + ret;
	}
	else {
		ret = ret + sp + symbol;
	}
	return ret;
};

store.checkout = {};
store.checkout.init = function() {
	var $mainBox = $('body.checkout #store.box');
	var $stepperContent = $mainBox.find('.stepperContent');
	if ($stepperContent.hasClass('payment')) {
		store.checkout.payment.init($mainBox);
	}
};
store.checkout.address = {};
store.checkout.address.initSelect = function() {
	$('.addressSelect').change(function(){
		var $this = $(this);
		var rel = $this.attr('rel');
		var addressId = $this.val();
		var divSel = '.'+rel + 'AddressWrap .addressWrap';
		$(divSel).load($this.parents('form').attr('data-load')+"/" + addressId);
	});
};
store.checkout.payment = {
	init: function($mainBox) {
		$mainBox.find('.ddSelect').each(function() {
			var $dd = $(this);
			var selectedValue = $dd.find('option[selected=selected]').val();
			$dd.ddSelect({
				ddSelectChange: function() {
					var $this = $(this);
					var $opts = $this.find('option');
					var $selected;
					if (selectedValue) {
						$selected = $opts.filter('[value=' + selectedValue + ']');
					}
					if (!$selected || $selected.length < 1) {
						$selected = $opts.filter(':last');
					}
					$selected.prop('selected', true);
				}
			});
			$dd.trigger('change');
		});
	}
};

if (jQuery) {
	jQuery('document').ready(store.checkout.init);
}

store.customize = (function() {
	// noinspection JSUnusedLocalSymbols
	var
		$store = $('#store'),
		$buyBox = $store.find('div.buyBox'),
		$form = $buyBox.find('form'),
		$ca = $buyBox.find('.customAttribute'),
		$submitButton = $form.find('#submitCart'),
		dummy = {customization: null}
	;

	function onInitProduct() {
		if ($ca.length < 1) {
			return;
		}
		initFileChange();
		initSubmitButton();
		handleAnyChange();
		initDagatal();
	}

	function onAddToCart(data) {
		if (data.customization) {
			if (data.customization.images) {
				for (var i in data.customization.images) {
					if (data.customization.images.hasOwnProperty(i)) {
						var base = data.customization.images[i];
						if (base) {
							var thumb = findThumbFromBase(base);
							if (thumb) {
								showThumb(i, thumb);
							}
						}
					}
				}
			}
		}
	}

	function findThumbFromBase(base) {
		var thumbBase = base.replace(/(\.jpg)$/, '_thumb$1');
		var thumbFolder = $ca.data('tmpfolder');
		return thumbFolder + '/' + thumbBase;
	}

	function showThumb(key, thumb) {
		var $file = $ca.find('#' + key);
		var $data = $file.parents('.customAttribute__data');
		removeImage($file);
		var $image = $('<div/>').addClass('customAttribute__image');
		var $img = $('<img/>').attr({
			src: thumb,
			alt: 'Image ' + key
		});
		$image.append($img);
		$data.append($image);
		// Don't clear the file element because we need the files to be reUploaded to connect them
	}

	function initFileChange() {
		$ca.find('input[type=file]').change(onFileChange);
	}

	function onFileChange() {
		var $this = $(this);
		var minSize = parseInt($this.data('minsize'));
		if (minSize > 0) {
			if (typeof this.files[0] !== 'undefined') {
				var size = this.files[0].size;
				if (size < minSize) {
					$this.val('');
					fileError($this, 'File to small');
					return;
				}
			}
		}
		if ($this.val()) {
			removeImage($this);
		}
	}

	function fileError($file, msg) {
		if (jQuery.ui) {
			$('<div/>').html(msg).dialog({
				title: 'Error',
				modal: true,
				buttons: {
					'Ok': function () {
						$(this).dialog('close');
						$file.effect('highlight', {}, 3000);
						$file.get(0).focus();
					}
				}
			});
		}
		else {
			alert(msg);
			$file.effect('highlight', {}, 3000);
			$file.get(0).focus();
		}
	}

	function removeImage($file) {
		var $img = $file.parents('.customAttribute__data').find('.customAttribute__image');
		if ($img.length > 0) {
			$img.remove();
		}
	}

	function initSubmitButton() {
		$ca.find(':input').change(handleAnyChange);
		var timer;
		$ca.find('textarea, input[type=text]').keyup(function() {
			if (timer) {
				clearTimeout(timer);
			}
			timer = setTimeout(handleAnyChange, 300);
		});
	}

	function handleAnyChange() {
		var valid = formIsValid();
		if (valid) {
			$submitButton.removeProp('disabled').removeClass('disabled');
		}
		else {
			$submitButton.attr('disabled', 'disabled').addClass('disabled');
		}
	}

	function formIsValid() {
		return store.isFormRequirementsValid($form);
	}

	function initDagatal() {
		var $files = $ca.find('input[type=file]');
		$files.on('dragover', function() {
			$(this).addClass('drop-active');
		}).on('dragleave', function() {
			$(this).removeClass('drop-active');
		}).on('drop', function() {
			$(this).addClass('dropped');
		}).change(function() {
			var $this = $(this);
			$this.removeClass('drop-active');
			if (!$this.val()) {
				$this.removeClass('dropped');
			}
		});
	}
	return {
		onAddToCart: onAddToCart,
		onInitProduct: onInitProduct
	};
})();

store.quickOrder = {
	stats: null,
	strings: [],
	init: function() {
		$(document).on('click', '.ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-title, .ui-datepicker-calendar', function (e) {
			e.stopPropagation();
		});

		store.quickOrder.strings.storeQuickOrderIsEmpty = $('#storeQuickOrderForm').html();

		store.quickOrder.initAutocomplete();
		store.quickOrder.initDatepicker();
		store.quickOrder.initCustomerStats();

		setTimeout(function() {
			store.quickOrder.initEvents();

			if (!store.quickOrder.hasItemsInStorage()) {
				// Render items from past year
				var to = new Date();
				var from = new Date();
				from.setFullYear(from.getFullYear() - 1);

				var fromString = from.getDate() + '.' + from.getMonth() + '.' + from.getFullYear();
				var toString = to.getDate() + '.' + to.getMonth() + '.' + to.getFullYear();
				store.quickOrder.importByRange(fromString, toString);
			}
			else {
				store.quickOrder.renderFromStorage();
			}
		}, 1000);
	},
	initEvents: function() {
		$('#storeQuickOrderImport').on('submit', function(e) {
			$('.dropdown-toggle').dropdown('toggle');

			e.preventDefault();

			var $form = $(this),
				formValues = [],
				values = $form.serializeArray();

			for (var i = 0, iMax = values.length; i < iMax; i++) {
				formValues[values[i].name] = values[i].value;
			}

			if (formValues.import) {
				if (formValues.import === 'lastorder') {
					if (confirm('Að sækja seinustu pöntun hreinsar út núverandi pöntun. Halda áfram?')) {
						store.quickOrder.importLastOrder();
					}
				}
				else {
					if (confirm('Að sækja eldri pantanir hreinsar út núverandi pöntun. Halda áfram?')) {
						store.quickOrder.importByRange(formValues.from, formValues.to);
					}
				}
			}
		});

		$('#storeQuickOrderFormReset').on('click', function(e) {
			e.preventDefault();

			if (confirm('Ertu viss um að þú viljir hreinsa pöntunina?')) {
				store.quickOrder.clear();
			}
		});

		$('#storeQuickOrderFormSubmit').on('click', function(e) {
			e.preventDefault();

			$.ajax({
				url: '/_/' + moya.lang + '/store/cart/bulkadd',
				method: 'post',
				data: $('#storeQuickOrderForm').serializeArray()
			}).done(function() {
				// Update miniCart
				store.cart.box();

				// Update mediumCart
				$.get(store.url(store.action.cartMedium, ''), function (data) {
					$('.cartBoxMedium').replaceWith(data.html);
					$('#storeCartBox .miniCart').trigger('click');
					store.quickOrder.clear();

				}, 'json');
			});
		});

		store.quickOrder.bindRemoveProduct();
	},
	initAutocomplete: function() {
		var $element = $('#storeQuickOrderSearch');
		if ($element.length) {
			$element.autocomplete({
				source: function( request, response ) {
					$.ajax({
						url: '/' + moya.lang + '/moya/store/api/autocomplete',
						dataType: "json",
						data: {
							query: encodeURIComponent(request.term)
						},
						success: function( data ) {
							response( data );
						}
					});
				},
				minLength: 2, // Need to search for "ís"
				select: store.quickOrder.autocompleteSelect,
				focus: store.quickOrder.autocompleteFocus,
				close: store.quickOrder.autocompleteClose,
			}).autocomplete( "instance" )._renderItem = store.quickOrder.autocompleteRender;
		}
	},

	initDatepicker: function() {
		var $element = $('.datepicker', '#storeQuickOrderImport');
		if ($element.length) {
			$element.datepicker({
				dateFormat: 'dd.mm.yy',
				onSelect: function(date, obj) {
					var $this = $(this);
					if ($this.attr('name') === 'from') {
						var $to = $('.datepicker[name="to"]', '#storeQuickOrderImport');
						$to.datepicker('option', 'minDate', date);
					}

					$('#storeQuickOrderImportDate').trigger('click');
				}
			});
		}
	},

	initCustomerStats: function() {
		store.quickOrder.customerStats = store.quickOrder.loadFromStorage('customerStats');

		if (!store.quickOrder.customerStats.length) {
			$.ajax({
				url: '/' + moya.lang + '/moya/store/api/customerstats',
				method: 'get'
			}).done(function(r) {
				if (r) {
					store.quickOrder.saveToStorage('customerStats', r);
					store.quickOrder.customerStats = r;
				}
			});
		}
	},

	importLastOrder: function() {
		store.quickOrder.renderLoading();

		$.ajax({
			url: '/' + moya.lang + '/moya/store/api/lastorder',
			method: 'get'
		}).done(function (r) {
			if (r) {
				store.quickOrder.clear();

				$.each(r, function (idx, item) {
					store.quickOrder.addItemToStorage(item);
				});

				store.quickOrder.renderFromStorage();
				store.quickOrder.bindRemoveProduct();
			}
			else {
				moya.message.add('Engin pöntun fannst');
				$('#storeQuickOrderGetLastOrder').addClass('disabled');
			}
		});
	},

	importByRange: function(from, to) {
		store.quickOrder.renderLoading();

		$.ajax({
			url: '/' + moya.lang + '/moya/store/api/orderitems',
			method: 'get',
			data: {
				from: from,
				to: to
			}
		}).done(function (r) {
			if (r) {
				store.quickOrder.clear();

				$.each(r, function (idx, item) {
					store.quickOrder.addItemToStorage(item);
				});

				store.quickOrder.renderFromStorage();
				store.quickOrder.bindRemoveProduct();
			}
			else {
				moya.message.add('Engin pöntun fannst');
				$('#storeQuickOrderGetLastOrder').addClass('disabled');
			}
		});
	},

	bindRemoveProduct: function() {
		$('.product__remove', '#storeQuickOrderForm').on('click', function() {
			var $this = $(this),
				$product = $this.parents('.product'),
				items = store.quickOrder.getItemsFromStorage();

			for (var i = 0, iMax = items.length; i < iMax; i++) {
				if (items[i].externalId == $product.data('externalid')) {
					items.splice(i, 1);
					break;
				}
			}
			store.quickOrder.saveToStorage('items', items);

			$product.remove();
		});
	},

	getProductCustomerStats: function(reference) {
		var string = '',
			label = '',
			value = '',
			orderItems = store.quickOrder.customerStats.orderItems;

		if (orderItems.allTime[reference]) {
			var history = orderItems.allTime[reference].history;
			var historyArray = Object.keys(history).map(function(key) {
				return [Number(key), history[key]];
			});

			var last = historyArray.slice(-1).pop();

			if (last) {
				label = 'Last order: ';
				if (moya.lang === 'is') { label = 'Seinast pantað: ';}
				var date = new Date(last[0]*1000);
				var dateString = date.getDate() + '.' + date.getMonth() + '.' + date.getFullYear();
				var qty = last[1];

				string += '<span class="stat">' + label + ' ' + dateString + ' <span class="stat__value">' + qty + '</span> stk.</span>';
			}

		}
		if (orderItems.oneMonth[reference]) {
			label = '1 month: ';
			if (moya.lang === 'is') { label = '1 mán: ';}
			value = orderItems.oneMonth[reference].totalOrdered;
			string += '<span class="stat">' + label + '<span class="stat__value">' + value + '</span>' + ' stk.</span>';
		}
		if (orderItems.sixMonths[reference]) {
			label = '6 months: ';
			if (moya.lang === 'is') { label = '6 mán: ';}
			value = orderItems.sixMonths[reference].totalOrdered;
			string += '<span class="stat">' + label + '<span class="stat__value">' + value + '</span>' + ' stk.</span>';
		}
		if (orderItems.twelveMonths[reference]) {
			label = '12 months: ';
			if (moya.lang === 'is') { label = '12 mán: ';}
			value = orderItems.twelveMonths[reference].totalOrdered;
			string += '<span class="stat">' + label + '<span class="stat__value">' + value + '</span>' + ' stk.</span>';
		}

		if (string) {
			return '<div class="product__stats">' + string + '</div>';
		}
	},

	autocompleteSelect: function(event, ui) {
		if (ui.item) {
			store.quickOrder.addItemToStorage(ui.item, true, function() {
				store.quickOrder.renderFromStorage();
				store.quickOrder.enableButtons();
				store.quickOrder.bindRemoveProduct();
				$('#storeQuickOrderForm').focus();
			});
		}

		return false;
	},
	autocompleteFocus: function(event, ui) {
		// Do nothing
		return false;
	},
	autocompleteClose: function(event, ui) {
		// Do nothing
		return false;
	},
	autocompleteRender: function( ul, item ) {
		var $li = $( "<li>" ),
			img = '';

		if (item.imageId) {
			img = '<img src="/static/store/images/xs/product_' + item.imageId + '.' + item.imageExt.toLowerCase() + '">';
		}

		$li.append('<span class="result__image">' + img + '</span>');

		if (item.vendorName) {
			$li.append('<span class="result__label">' + item.vendorName + '</span>');
		}

		$li.append('<span class="result__sublabel">' + item.variantName[moya.lang] + '</span>');
		$li.append('<span class="result__reference">' + item.reference + '</span>');
		$li.wrapInner('<div class="result">').appendTo( ul );

		return $li;
	},

	addItemToStorage: function(item, prepend, callback) {
		items = store.quickOrder.getItemsFromStorage();
		if (prepend) {
			items.unshift(item);
		}
		else {
			items.push(item);
		}
		items = store.quickOrder.saveToStorage('items', items);

		if (callback) {
			callback();
		}
	},

	addItemQuantityToStorage: function(quantity, itemId) {
		items = store.quickOrder.getItemsFromStorage();
		$.each(items, function(idx, item) {
			if (item.id === itemId) {
				item.quantity = quantity;
				items[idx] = item;
				return true;
			}
		});
		items = store.quickOrder.saveToStorage('items', items);
	},

	clearItemStorage: function() {
		window.localStorage.removeItem('items');
		window.localStorage.removeItem('customerStats');
	},

	clear: function() {
		store.quickOrder.clearItemStorage();
		store.quickOrder.renderFromStorage();
	},

	getItemsFromStorage: function() {
		return store.quickOrder.loadFromStorage('items');
	},

	hasItemsInStorage: function() {
		return (store.quickOrder.getItemsFromStorage().length > 0);
	},

	loadFromStorage: function(key) {
		var values = window.localStorage.getItem(key);

		if (!values) {
			values = [];
		}
		else {
			values = JSON.parse(values);
		}

		// Check if data has a timestamp
		if (values.lastUpdated) {
			var now = Date.now() / 1000 | 0;
			// If data is older than 24 hrs invalidate and return nothing
			if (now && now > values.lastUpdated + 86400) {
				values = [];
			}
		}

		return values;
	},

	saveToStorage: function(key, value) {
		window.localStorage.setItem(key, JSON.stringify(value));
	},

	enableButtons: function() {
		$('#storeQuickOrderFormSubmit').removeClass('disabled');
		$('#storeQuickOrderFormReset').removeClass('disabled');
	},

	disableButtons: function() {
		$('#storeQuickOrderFormSubmit').addClass('disabled');
		$('#storeQuickOrderFormReset').addClass('disabled');
	},

	renderLoading: function() {
		$form = $('#storeQuickOrderForm');
		if ($form) {
			var string = 'Loading products...';
			if (moya.lang === 'is') {
				string = 'Hleð inn vörum...';
			}
			$form.html(string);
		}
	},

	renderFromStorage: function() {
		$form = $('#storeQuickOrderForm');
		if ($form) {
			if (store.quickOrder.hasItemsInStorage()) {
				$form.html('');
				var items = store.quickOrder.getItemsFromStorage();

				store.quickOrder.enableButtons();
				store.quickOrder.renderSorter().appendTo($form);
				var $products = $('<div class="products">').appendTo($form);

				var inactiveLabel = 'Product no longer exists';
				if (moya.lang === 'is') {
					inactiveLabel = 'Vara ekki lengur fáanleg';
				}

				$.each(items, function(index, item) {
					var $product = $('<div class="product" data-externalid="'+item.externalId+'">'),
						img = '',
						imgUrl = '';

					if (item.imageId) {
						imgUrl = '/static/store/images/xs/product_' + item.imageId + '.' + item.imageExt.toLowerCase();
						img = '<a href="'+imgUrl+'" class="fancybox" style="background-image:url('+imgUrl+')"></a>';
					}
					if (item.active < 1) {
						$product.addClass('inactive');
						$product.attr('title', inactiveLabel);
					}

					$product.append('<div class="product__image">' + img + '</div>');

					store.quickOrder.renderProductDetails(item).appendTo($product);
					store.quickOrder.renderProductAside(item).appendTo($product);

					$product.append('<div class="product__remove"></div>');

					$product.appendTo($products);
				});
			}

			$('#storeQuickOrderSearch').val('').focus();

			$('.product__qty input[type="number"]', '#storeQuickOrderForm').on('keyup input', function(e) {
				e.preventDefault();
				var $this = $(this),
					id = $this.attr('name').replace(/\D+/g, '');

				if ($this.val() > 0) {
					$this.addClass('active');
				}
				else {
					$this.val('').removeClass('active');
				}

				store.quickOrder.addItemQuantityToStorage($this.val(), id);
			});
		}
	},

	renderSorter: function() {
		var $sorter = $('<div class="sorter">Raða eftir:</div>');
		$('<a href="#" onclick="return store.quickOrder.sortByTitle();">Vöruheiti</a>').appendTo($sorter);
		$('<a href="#" onclick="return store.quickOrder.sortByReference();">Vörunúmeri</a>').appendTo($sorter);
		return $sorter;
	},

	renderProductDetails: function(item){
		var $details = $('<div class="product__details">');

		if (item.vendorName) {
			$details.append('<span class="product__label">' + item.vendorName + '</span>');
		}

		if (item.url) {
			$details.append('<span class="product__sublabel"><a href="' + item.url + '" target="_blank">' + item.variantName[moya.lang] + '</a></span>');
		}
		else {
			$details.append('<span class="product__sublabel">' + item.variantName[moya.lang] + '</span>');
		}

		if (item.ExtraDesc5) {
			var count = 1;
			if (item.ExtraDesc5.indexOf('KS') === 0) {
				count = item.ExtraDesc5.replace(/\D+/g, '');
			}
			$details.append('<span class="product__lot">' + count + ' stk. í pakka</span>');
		}
		if (item.weight) {
			$details.append('<span class="product__weight">' + item.weight + ' kg.</span>');
		}

		var $priceDetails = $('<div class="product__priceDetails">');

		if (item.price) {
			$priceDetails.append('<span class="product__price">Listaverð:' + item.price.substring(0, item.price.indexOf('.')) + ' kr.</span>');
		}
		if (item.discountPrice) {
			$priceDetails.append('<span class="product__discountPrice">Mitt verð: ' + Math.round(item.discountPrice) + ' kr.</span>');
		}
		if (item.price && item.discountPrice) {
			var discount = 1 - Math.round(item.discountPrice) / item.price.substring(0, item.price.indexOf('.'));
			$priceDetails.append('<span class="product__discountPercentage">Afsláttur: ' + Math.round(discount * 100) + ' %.</span>');
		}

		if (item.discountPriceText) {
			$priceDetails.append('<span class="product__discountPriceText"><span>Tilboð: </span>' + item.discountPriceText + '</span>');
		}

		$details.append($priceDetails);


		$details.append(store.quickOrder.getProductCustomerStats(item.reference));

		return $details;
	},

	renderProductAside: function(item){
		var $aside = $('<div class="product__aside">');

		$aside.append('<span class="product__reference">Vnr. ' + item.reference + '</span>');

		var $qtyWrap = store.quickOrder.renderProductQtyWrap(item);
		$aside.append($qtyWrap);
		$aside.append('<input type="hidden" name="price[' + item.id + ']" value="' + item.basePriceId + '">');
		$aside.append('<input type="hidden" name="category[' + item.id + ']" value="' + item.categoryId +'">');

		return $aside;
	},

	renderProductQtyWrap: function(item) {
		var step = 1;
		var qtyLabel = 'Quantity';
		var outOfStockLable = 'Out of stock';
		var $qtyWrap = $('<span class="product__qty">');

		if (moya.lang === 'is') {
			qtyLabel = 'Fjöldi';
			outOfStockLable = 'Vara uppseld';
		}

		if (item.ExtraDesc5) {
			if (item.ExtraDesc5.indexOf('KS') === 0) {
				step = item.ExtraDesc5.replace(/\D+/g, '');
			}
		}

		var $qtyInput = $('<input type="number"/>');
		$qtyInput.prop('name', 'qty[' + item.id + ']');
		$qtyInput.prop('step', step);
		$qtyInput.prop('max', item.stock);
		if (item.quantity && item.quantity > 0) {
			$qtyInput.val(item.quantity);
			$qtyInput.addClass('active');
		}
		$qtyWrap.append(qtyLabel);
		$qtyWrap.append($qtyInput);
		if (item.active < 1 || item.stock < 1) {
			$qtyInput.prop('disabled', 'disabled');
			$qtyInput.attr('title', outOfStockLable);
		}
		return $qtyWrap;
	},

	sortByTitle: function() {
		var $form = $('#storeQuickOrderForm'),
			$products = $form.find('.product');

		$products.sort(function(a, b) {
			var aid = $(a).find('.product__sublabel').text().toLowerCase(),
				bid = $(b).find('.product__sublabel').text().toLowerCase();

			if (aid > bid) {
				return 1;
			}

			if (aid < bid) {
				return -1;
			}

			return 0;
		});

		$form.find('.products').html($products);
		store.quickOrder.bindRemoveProduct();
		return false;
	},

	sortByReference: function() {
		var $form = $('#storeQuickOrderForm'),
			$products = $form.find('.product');

		$products.sort(function(a, b) {
			var aid = parseInt($(a).data('externalid')),
				bid = parseInt($(b).data('externalid'));

			if (aid > bid) {
				return 1;
			}

			if (aid < bid) {
				return -1;
			}

			return 0;
		});

		$form.find('.products').html($products);
		store.quickOrder.bindRemoveProduct();
		return false;
	}
};


(function ($) {
	$.fn.ddSelect = function (opts) {
		var $dd = this.filter('select'),
			listen = $dd.data('ddselect-listen'),
			$form = $dd.parents('form'),
			settings = $.extend({}, opts),
			setList = function($select, raw) {
				var $items = [];
				var a = raw.split(';');
				$.each(a, function(key, item) {
					var tmp = item.split('=');
					if (tmp.length === 2) {
						$items.push($('<option>', {value: tmp[0]}).text(tmp[1]));
					}
				});
				if ($items.length > 0) {
					$select.empty().append($items);
					$select.trigger('change');
					$select.trigger('ddSelectChange');
				}
			}
		;
		if (settings.ddSelectChange) {
			$dd.on('ddSelectChange', settings.ddSelectChange);
		}
		$form.find(listen).change(function() {
			var $this = $(this);
			var value = $this.val();
			if (value) {
				var key = 'ddselect-' + value;
				var raw = $dd.data(key);
				if (raw) {
					setList($dd, raw);
				}
			}
		}).trigger('change');
	};
}(jQuery));

store.local = store.local || {};
store.local.onInit = store.local.onInit || function(){};
store.local.onUpdateAttribute = store.local.onUpdateAttribute || function(variant){};
store.local.onUpdateVariantData = store.local.onUpdateVariantData || function(variant){};
store.local.onSelectVariant = store.local.onSelectVariant || function(currentVariantKey){};
store.local.onInitProduct = store.local.onInitProduct || function(){};
store.local.onAddToCart = store.local.onAddToCart || function(){};
store.local.onCartIncrease = store.local.onCartIncrease || function(){};
store.local.onCartDecrease = store.local.onCartDecrease || function(){};
store.local.onCartBox = store.local.onCartBox || function(){};
store.local.onFilterUpdate = store.local.onFilterUpdate || function(){};
store.local.onCategoryProductsUpdate = store.local.onCategoryProductsUpdate || function(){};
store.local.prepareTermsDialogParams = store.local.prepareTermsDialogParams || function($dialog, $link){};
store.local.showMessage = false;

//# sourceMappingURL=data:application/json;charset=utf8;base64,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
